<div class="container">
  <div class="row">
    <div class="col"></div>
    <div class="col-5 my-12">
      <div class="col-6 offset-md-3"><img _ngcontent-c5="" src="assets/images/logo/Poured_logo_1.png"></div>
      <form class="form-signin" [formGroup]="loginForm" (ngSubmit)="userLoginAction()">
        <h2 class="form-signin-heading text-center mb-4"></h2>
        <label for="inputEmail" class="sr-only">Email address</label>
        <input type="email" id="inputEmail" class="form-control mb-3" placeholder="Email address" formControlName="email"
               required autofocus autocomplete="off">
        <label for="inputPassword" class="sr-only">Password</label>
        <input type="password" id="inputPassword" class="form-control mb-3" placeholder="Password" formControlName="password"
               required autocomplete="off">
        <button class="btn btn-lg btn-primary btn-block" type="submit" [disabled]="!loginForm.valid">Sign in</button>
      </form>
    </div>
    <div class="col"></div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/login/login.component.html